import { useMemo } from "react";

export const Blossom = ({ className = "", style }) => (
  <svg viewBox="0 0 40 40" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M20 2c3.2 4.2 3.2 8.6 0 12.4C16.8 10.6 16.8 6.2 20 2z" />
    <path d="M37.4 13.6c-1.4 5.2-4.6 8.2-9.2 8.6 1.4-5.2 4.6-8.2 9.2-8.6z" />
    <path d="M31.6 35.2c-5-1.8-7.7-5.2-7.6-10.2 5 1.8 7.7 5.2 7.6 10.2z" />
    <path d="M8.4 35.2c-.1-5 2.6-8.4 7.6-10.2.1 5-2.6 8.4-7.6 10.2z" />
    <path d="M2.6 13.6c4.6.4 7.8 3.4 9.2 8.6-4.6-.4-7.8-3.4-9.2-8.6z" />
    <circle cx="20" cy="20" r="3.4" fill="#C9A227" />
  </svg>
);

export const BlossomBranch = ({ className = "", style }) => (
  <svg viewBox="0 0 300 420" className={className} style={style} fill="none" aria-hidden="true">
    <path
      d="M-20 400 C 60 340, 40 260, 120 200 C 180 155, 190 90, 250 30"
      stroke="#7E4B4B"
      strokeWidth="7"
      strokeLinecap="round"
      opacity="0.55"
    />
    <path d="M120 200 C 150 180, 155 140, 200 120" stroke="#7E4B4B" strokeWidth="5" strokeLinecap="round" opacity="0.45" />
    <path d="M70 300 C 110 290, 130 260, 170 255" stroke="#7E4B4B" strokeWidth="4" strokeLinecap="round" opacity="0.4" />
    {[
      [248, 32, 34, "#E8B4B8"], [206, 118, 26, "#F0C6CB"], [170, 254, 24, "#E8B4B8"],
      [122, 198, 30, "#F0C6CB"], [66, 298, 26, "#E8B4B8"], [286, 96, 20, "#F0C6CB"],
      [40, 360, 22, "#E8B4B8"], [150, 150, 18, "#F6D8DB"],
    ].map(([cx, cy, r, fill], i) => (
      <g key={i} transform={`translate(${cx} ${cy})`}>
        {[0, 72, 144, 216, 288].map((deg) => (
          <ellipse key={deg} cx="0" cy={-r * 0.52} rx={r * 0.34} ry={r * 0.52} fill={fill} opacity="0.9" transform={`rotate(${deg})`} />
        ))}
        <circle r={r * 0.16} fill="#C9A227" />
      </g>
    ))}
  </svg>
);

export const Lantern = ({ className = "", style, delay = 0 }) => (
  <svg viewBox="0 0 60 120" className={`lantern-sway ${className}`} style={{ animationDelay: `${delay}s`, ...style }} aria-hidden="true">
    <line x1="30" y1="0" x2="30" y2="18" stroke="#C9A227" strokeWidth="2.5" />
    <rect x="22" y="18" width="16" height="7" rx="3" fill="#C9A227" />
    <ellipse cx="30" cy="55" rx="22" ry="30" fill="#C9A227" opacity="0.92" />
    <ellipse cx="30" cy="55" rx="22" ry="30" fill="url(#lglow)" />
    <path d="M12 45 Q30 52 48 45 M12 65 Q30 58 48 65" stroke="#9B2C2C" strokeWidth="1.6" fill="none" opacity="0.5" />
    <line x1="30" y1="25" x2="30" y2="85" stroke="#9B2C2C" strokeWidth="1.2" opacity="0.35" />
    <rect x="25" y="85" width="10" height="6" rx="2.5" fill="#C9A227" />
    <line x1="30" y1="91" x2="30" y2="106" stroke="#C9A227" strokeWidth="2" />
    <circle cx="30" cy="110" r="4" fill="#9B2C2C" opacity="0.85" />
    <defs>
      <radialGradient id="lglow" cx="0.5" cy="0.42" r="0.7">
        <stop offset="0%" stopColor="#FFE9A8" />
        <stop offset="100%" stopColor="#C9A227" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const Flourish = ({ className = "" }) => (
  <svg viewBox="0 0 220 16" className={className} aria-hidden="true">
    <path d="M0 8 H86" stroke="#C9A227" strokeWidth="1.4" />
    <path d="M134 8 H220" stroke="#C9A227" strokeWidth="1.4" />
    <path d="M110 1c2.4 3.4 2.4 6.6 0 9.4-2.4-2.8-2.4-6 0-9.4z" fill="#E8B4B8" />
    <path d="M98 8c3-2 6.6-1.4 8.6 1.4-3 2-6.6 1.4-8.6-1.4z" fill="#E8B4B8" opacity="0.85" />
    <path d="M122 8c-3-2-6.6-1.4-8.6 1.4 3 2 6.6 1.4 8.6-1.4z" fill="#E8B4B8" opacity="0.85" />
    <circle cx="92" cy="8" r="1.8" fill="#C9A227" />
    <circle cx="128" cy="8" r="1.8" fill="#C9A227" />
  </svg>
);

export const HeartMotif = ({ className = "" }) => (
  <svg viewBox="0 0 24 22" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12 20.5C5.5 15.5 1.5 11.8 1.5 7.4 1.5 4.3 3.9 2 6.9 2c2 0 3.9 1.1 5.1 3 1.2-1.9 3.1-3 5.1-3 3 0 5.4 2.3 5.4 5.4 0 4.4-4 8.1-10.5 13.1z" />
  </svg>
);

const PETAL_COLORS = ["#E8B4B8", "#F0C6CB", "#F6D8DB", "#E5A0A6"];

export const PetalField = ({ count = 14, className = "" }) => {
  const petals = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: `${(i * 67 + 13) % 100}%`,
        size: 10 + ((i * 37) % 14),
        duration: 11 + ((i * 29) % 12),
        delay: -((i * 41) % 16),
        drift: 30 + ((i * 53) % 60),
        color: PETAL_COLORS[i % PETAL_COLORS.length],
        opacity: 0.35 + ((i * 17) % 40) / 100,
      })),
    [count]
  );
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {petals.map((p, i) => (
        <svg
          key={i}
          className="petal"
          viewBox="0 0 20 26"
          width={p.size}
          height={p.size * 1.3}
          style={{
            left: p.left,
            "--petal-duration": `${p.duration}s`,
            "--petal-delay": `${p.delay}s`,
            "--petal-drift": `${p.drift}px`,
            "--petal-opacity": p.opacity,
          }}
        >
          <path d="M10 1C16 7 18 14 10 25 2 14 4 7 10 1z" fill={p.color} />
        </svg>
      ))}
    </div>
  );
};

export const CornerFlora = ({ className = "" }) => (
  <svg viewBox="0 0 90 90" className={className} aria-hidden="true">
    <path d="M2 88 C 20 70, 18 40, 44 22" stroke="#E8B4B8" strokeWidth="2.4" fill="none" opacity="0.9" />
    <g transform="translate(46 20)">
      {[0, 72, 144, 216, 288].map((deg) => (
        <ellipse key={deg} cx="0" cy="-7" rx="4.4" ry="7" fill="#E8B4B8" transform={`rotate(${deg})`} />
      ))}
      <circle r="2.4" fill="#C9A227" />
    </g>
    <g transform="translate(18 62)">
      {[0, 72, 144, 216, 288].map((deg) => (
        <ellipse key={deg} cx="0" cy="-5" rx="3.2" ry="5" fill="#F0C6CB" transform={`rotate(${deg})`} />
      ))}
      <circle r="1.7" fill="#C9A227" />
    </g>
  </svg>
);
